<template>


    <div class="container">


        <div class="handle-box-search">
            <el-row class="head-search">

                <el-col :span="8">
                    <span class="title">订单编码:</span>
                    <!-- 搜索司机名称-->
                    <el-input v-model="search_data.order_code" placeholder="请输入订单编码" class="handle-input mr10"
                              @keyup.enter.native="searchcouponRecordLists"></el-input>
                </el-col>
                <el-col :span="8">
                    <span class="title">优惠券编码:</span>
                    <!-- 搜索司机名称-->
                    <el-input v-model="search_data.coupon_code" placeholder="请输入优惠券编码" class="handle-input mr10"
                              @keyup.enter.native="searchcouponRecordLists"></el-input>
                </el-col>
            </el-row>


            <el-row class="head-search">
                <div
                        style="margin: 10px 0;"
                        class="search-radio fs-big"
                >
                    <span class="title">类型:</span>
                    <el-radio-group
                            v-model="search_data.mode"
                            size="small"
                    >

                        <el-radio
                                label=""
                                border
                        >
                            全部
                        </el-radio>
                        <el-radio label="able" border>启用</el-radio>
                        <el-radio label="disable" border>禁用</el-radio>
                        <el-radio label="add" border>新增</el-radio>
                        <el-radio label="sub" border>使用</el-radio>
                        <el-radio label="out_time" border>过期</el-radio>

                    </el-radio-group>
                </div>
            </el-row>


            <div>
                <el-button type="primary" icon="el-icon-search" @click="searchcouponRecordLists">搜索</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            </div>


        </div>


        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


            <el-table-column prop="coupon.details.coupon_mode.details.name" label="优惠券名称" width="150">
            </el-table-column>

            <el-table-column prop="coupon.details.source.alias" label="类型">

                <template slot-scope="scope">

                    <el-tag :type="scope.row.mode.alias=='禁用'||scope.row.mode.alias=='过期'?'danger':(scope.row.mode.alias=='启用'||scope.row.mode.alias=='使用'?'success':'warning')"
                            size="medium">
                        {{ scope.row.mode.alias }}
                    </el-tag>

                </template>

            </el-table-column>

            <el-table-column prop="coupon.details.city.name" label="所属城市" width="300">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>城市唯一编码: {{ scope.row.coupon.details.city.city_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">
                                {{ scope.row.coupon.details.city.name }}
                            </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="coupon.details.consumer.details.name" label="拥有人" width="150">
            </el-table-column>

            <el-table-column prop="coupon.details.consumer.details.phone" label="拥有人电话" width="150">
            </el-table-column>

            <el-table-column prop="coupon.details.source.alias" label="状态">

                <template slot-scope="scope">

                    <el-tag :type="scope.row.coupon.details.status.val=='0'?'warning':(scope.row.coupon.details.status.val=='1'?'':'danger')"
                            size="medium">
                        {{ scope.row.coupon.details.status.alias }}
                    </el-tag>

                </template>

            </el-table-column>


            <el-table-column prop="coupon.details.source.alias" label="来源">
            </el-table-column>


        </el-table>


        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


    </div>


</template>

<script>
    var _this;
    export default {
        data() {
            return {

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    order_code: '',
                    coupon_code: '',
                    mode: ''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {

            _this = this;


            if (_this.$route.query.coupon_code) {
                _this.search_data.coupon_code = _this.$route.query.coupon_code;

            }

            if (_this.$route.query.order_code) {
                _this.search_data.order_code = _this.$route.query.order_code;

            }


            _this.couponRecordLists();


        },

        methods: {
            searchcouponRecordLists() {

                _this.search_data.page = 1;
                _this.couponRecordLists();

            },


            // 搜索用户管理列表
            couponRecordLists() {
                _this.$post(
                    '/coupon/couponRecordLists',
                    _this.search_data,
                    _this.search_rules
                ).then(res => {


                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;


                }).catch((err) => {

                });
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.couponRecordLists();

            },



            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }


        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>